module.exports = __webpack_public_path__ + "static/media/icon_view_right.61a01538.svg";